import * as React from "react";
import { Modal, ModalSize, SpinnerWrapper, Form, ModalBody, AlertMessage, AlertType, ModalFooter, CustomButton, CustomSubmitButton, ButtonType, FileUpload, CustomSubmitButtonType, Select } from "soprasteria-ui-library";
import { ISubmitXmlFile } from "../../../models/IImportedXml";
import { setMessage } from "../../../helpers/MessageHelper";
import { megaBytesToBytes } from "../../../helpers/FileHelper";
import { IListItem } from "soprasteria-ui-library/dist/models/IFormInput";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileUpload } from "@fortawesome/free-solid-svg-icons";
import { useAuth } from "../../../App";
import { ImportXmlApi } from "../../../api/ImportXmlApi";

interface IUploadXmlModal {
    xmlTypes: IListItem[];
    renderForm: boolean;
    onSuccess: (msg: string) => void;
    onClose: () => void;
    isFetchingXmlTypes: boolean;
}

export const UploadXmlModal: React.FunctionComponent<IUploadXmlModal> = ({ xmlTypes, renderForm, onSuccess, onClose, isFetchingXmlTypes }) => {

    const auth = useAuth();
    const api = new ImportXmlApi(auth);

    const [errorMessage, setErrorMessage] = React.useState<string>("");
    const [isSubmittingFile, setIsSubmittingFile] = React.useState<boolean>(false);
    const [numberOfFiles, setNumberOfFiles] = React.useState<number>(0);
    const [selectedFileType, setSelectedFileType] = React.useState<string>();

    const submitForm = (xml: ISubmitXmlFile) => {
        setIsSubmittingFile(true);
        api.uploadXmlFile(xml, () => {
            document.getElementById("close-upload-xml-modal")?.click();
            onSuccess("XML-filen laddades upp");
        }, (error) => {
            changeErrorMessage(error);
        }, () => {
            setIsSubmittingFile(false);
        });
    }

    const onFormClose = () => {
        setSelectedFileType(undefined);
        resetFormState();
        onClose();
    }

    const resetFormState = () => {
        setErrorMessage("");
        setIsSubmittingFile(false);
        setNumberOfFiles(0);
    }

    const changeErrorMessage = (message: string) => {
        const newMessage = setMessage(message, errorMessage)
        setErrorMessage(newMessage);
    }

    return (
        <Modal modalSize={ModalSize.large} header="Importera ny fil" id="upload-xml-modal">
            <SpinnerWrapper isLoading={isFetchingXmlTypes} >
                {
                    renderForm ?
                        <Form onSubmit={submitForm}>
                            <ModalBody>
                                <AlertMessage alertType={AlertType.danger} duration={3000}>{errorMessage}</AlertMessage>
                                <Select name="importedXmlTypeId" label="Typ av fil" options={xmlTypes} onChange={(val) => setSelectedFileType(val)} required inlineLabel />
                                {
                                    selectedFileType ?
                                        <FileUpload name="documents"
                                            label="Fil för inläsning (.XML)"
                                            maxSizeBytes={megaBytesToBytes(5)}
                                            allowedFileTypes={[".xml"]}
                                            inlineLabel
                                            required
                                            labelCol={2}
                                            inputCol={10}
                                            numOfFiles={setNumberOfFiles}
                                        />
                                        : null
                                }
                            </ModalBody>
                            <ModalFooter>
                                <CustomButton buttonType={ButtonType.general} id="close-upload-xml-modal" buttonText="Stäng" data-dismiss="modal" onClick={() => onFormClose()} />
                                <CustomSubmitButton isLoading={isSubmittingFile} buttonType={CustomSubmitButtonType.default} disabled={numberOfFiles !== 1}><FontAwesomeIcon icon={faFileUpload} /> Ladda upp fil</CustomSubmitButton>
                            </ModalFooter>
                        </Form>
                        : null
                }
            </SpinnerWrapper>
        </Modal>
    );
}